<div class="toast-container position-absolute top-0 start-50 translate-middle-x p-3">
<div id="internettoast" class="toast bg-danger-subtle" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header bg-danger">
      <strong class="mx-auto text-white">OFFLINE ALERT</strong>
    </div>
    <div class="toast-body">
        Oops!! Looks like you are not connected to internet.
    </div>
  </div>
</div>
<router-outlet></router-outlet>